// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__TisCard from "./TisCard.js";
import * as Buhta_landing__TisCardMobile from "./TisCardMobile.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function TisGeneral(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("img", {
          className: "lg:h-100 lg:w-252",
          alt: "tis",
          src: StaticAsset.src("/static/images/tis.svg")
        }),
        className: "lg:flex lg:m-auto lg:w-252 lg:h-100 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h1", {
            children: "Трехкомпонентная интегрированная система Бухта",
            className: "h3 lg:h1 text-center lg:flex lg:mx-auto mt-16 lg:w-252 text-black-landing"
          }),
          JsxRuntime.jsx("h5", {
            children: "Система учета позволяющая увеличить обороты по НДС и упрощенке в 5 раз",
            className: "paragraph-large lg:h5 lg:flex lg:m-auto mt-4 lg:mt-6 lg:justify-center text-center lg:text-left lg:w-252 text-black-landing"
          }),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "flex m-auto mt-8 lg:mt-16",
              tl: /* [] */ 0
            },
            label: Buhta_landing__I18n.trans(intl, "start_using"),
            onClick: (function (param) {
              Buhta_landing__EventHandlers.scrollToFooter(deviceType);
            })
          })
        ],
        className: "px-6 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h3", {
                children: "Общие сведения",
                className: "h4 lg:h3 text-black-landing sm:text-center"
              }),
              JsxRuntime.jsx("p", {
                children: "Трехкомпонентная интегрированная система Бухта - это информационная система, состоящая из следующих компонентов:",
                className: "paragraph-large lg:h-light lg:flex lg:mx-auto mt-2 sm:text-center text-black-landing lg:w-196.25"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("span", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "inline mr-2",
                        src: StaticAsset.src("/static/icons/check-blue.svg")
                      }),
                      "Автоматизированно"
                    ],
                    className: "paragraph lg:paragraph-large text-primary sm:ml-8 mt-2 lg:mt-0 first:ml-0"
                  }),
                  JsxRuntime.jsxs("span", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "inline mr-2",
                        src: StaticAsset.src("/static/icons/check-blue.svg")
                      }),
                      "Быстро"
                    ],
                    className: "paragraph lg:paragraph-large text-primary sm:ml-8 mt-2 lg:mt-0 first:ml-0"
                  }),
                  JsxRuntime.jsxs("span", {
                    children: [
                      JsxRuntime.jsx("img", {
                        className: "inline mr-2",
                        src: StaticAsset.src("/static/icons/check-blue.svg")
                      }),
                      "Масштабируемо"
                    ],
                    className: "paragraph lg:paragraph-large text-primary sm:ml-8 mt-2 lg:mt-0 first:ml-0"
                  })
                ],
                className: "flex justify-center flex-col sm:flex-row mt-4 lg:mt-6"
              })
            ],
            className: "px-6 sm:px-24 md:px-0"
          }),
          deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsx(Buhta_landing__TisCardMobile.make, {}) : JsxRuntime.jsx(Buhta_landing__TisCard.make, {}),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "flex m-auto mt-10 lg:mt-20",
              tl: /* [] */ 0
            },
            label: Buhta_landing__I18n.trans(intl, "start_using"),
            onClick: (function (param) {
              Buhta_landing__EventHandlers.scrollToFooter(deviceType);
            })
          }),
          JsxRuntime.jsx("p", {
            children: "Уже пользуются 125 предпринимателей",
            className: "paragraph-small text-center text-gray-landing mt-4"
          })
        ],
        className: "bg-bg mt-16 lg:mt-40 py-10 lg:py-40 sm:px-48"
      })
    ],
    className: "bg-white lg:pt-40 lg:px-0"
  });
}

const make = TisGeneral;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
